import { render, staticRenderFns } from "./TableDispatch.vue?vue&type=template&id=183cc44e&"
import script from "./TableDispatch.vue?vue&type=script&lang=ts&"
export * from "./TableDispatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports